import Vue from 'vue'
import Router from 'vue-router'

import MemberLogin from '@/components/Member/Login'
import MemberInfo from '@/components/Member/Info'

import VideoCourseList from '@/components/VideoCourse/List'
import VideoCourseDetail from '@/components/VideoCourse/Detail'
import MyVideoCourse from '@/components/VideoCourse/MyCourse'

import QuestionsPaperList from '@/components/QuestionsPaper/List'
import QuestionsPaperDetail from '@/components/QuestionsPaper/Detail'
import QuestionsPaperResult from '@/components/QuestionsPaper/Result'
import MyExam from '@/components/QuestionsPaper/MyExam'


Vue.use(Router)

export default new Router({
  routes: [
    /**
     * 登录页面
     */
    {
      path: '/login',
      component: MemberLogin,
    },
    /**
     * 首页、概况页面
     */
    {
      path: '/',
      redirect: '/course_list'
    },
    {
      path: '/course_list',
      name: 'VideoCourseList',
      component: VideoCourseList
    },
    {
      path: '/course_detail',
      name: 'VideoCourseDetail',
      component: VideoCourseDetail
    },
    {
      path: '/my_course',
      name: 'MyVideoCourse',
      component: MyVideoCourse
    },
    {
      path: '/exam_list',
      name: 'QuestionsPaperList',
      component: QuestionsPaperList
    },
    {
      path: '/exam_detail',
      name: 'QuestionsPaperDetail',
      component: QuestionsPaperDetail
    },
    {
      path: '/exam_result',
      name: 'QuestionsPaperResult',
      component: QuestionsPaperResult
    },
    {
      path: '/my_exam',
      name: 'MyExam',
      component: MyExam
    },
    {
      path: '/member_info',
      name: 'MemberInfo',
      component: MemberInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js